import { SET_VALUES_PROFILE, CLEAR_VALUES_PROFILE } from '@constants/actionType'

const initialState = {
  general: null,
  permissionSelect: [],
  permissionCatalog: [],
  accessibility: null,
  id: null
};

function admin(state = initialState, actions) {
  switch (actions.type) {
    case SET_VALUES_PROFILE:
      return { ...state, ...actions.payload };
    case CLEAR_VALUES_PROFILE:
      return {
        general: null,
        permissionSelect: [],
        permissionCatalog: [],
        accessibility: null,
        id: null
      };
    default:
      return state;
  }
}

export default admin;
